/*
  Pashion: tap support for the "i" more-info trigger on PDP icon blocks.

  Broadcast's <tooltip-component> shows its tooltip on mouseenter and hides on
  mouseleave, which covers desktop hover. On touch there is no reliable
  mouseleave, so this toggles the same tooltip on click: first tap opens it
  (via the component's `theme:tooltip:init` event), a second tap or a tap
  anywhere else closes it (via the document-level `theme:tooltip:close` event
  the theme already listens for). Keyboard users get the same via Enter/Space
  on the button.
*/
(function () {
  'use strict';

  var TRIGGER = '[data-icon-info]';
  var BUTTON = '.block__icon__info__btn';
  var TOOLTIP = '.tooltip-default';
  var open = null;

  function closeAll() {
    document.dispatchEvent(
      new CustomEvent('theme:tooltip:close', {
        bubbles: true,
        detail: { hideTransition: true, immediate: true },
      })
    );
    if (open) open.querySelector(BUTTON).setAttribute('aria-expanded', 'false');
    open = null;
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest(BUTTON);

    if (!button) {
      if (open && !event.target.closest(TOOLTIP)) closeAll();
      return;
    }

    event.preventDefault();
    var trigger = button.closest(TRIGGER);
    var tooltip = document.querySelector(TOOLTIP);
    var isOpen = open === trigger && tooltip && tooltip.classList.contains('is-visible');

    if (isOpen) {
      closeAll();
      return;
    }

    closeAll();
    trigger.dispatchEvent(new CustomEvent('theme:tooltip:init'));
    button.setAttribute('aria-expanded', 'true');
    open = trigger;
  });

  // The theme hides the tooltip on scroll; keep the button state in sync.
  document.addEventListener('theme:scroll', function () {
    if (open) {
      open.querySelector(BUTTON).setAttribute('aria-expanded', 'false');
      open = null;
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && open) closeAll();
  });
})();
